import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";
import { PhoneCountryPicklist } from "../../helpers/phone-number-validation-helper";

export interface RistaCardState {
  newCardData: any;
  cardDetails: any;
  phoneCountries: PhoneCountryPicklist[];
}

const initialState: RistaCardState = {
  newCardData: null,
  cardDetails: null,
  phoneCountries: [],
};

export const ristaCardSlice = createSlice({
  name: "ristaCard",
  initialState,
  reducers: {
    createNewCardData: (state, action) => {},
    saveCardData: (state, action) => {
      state.newCardData = action.payload;
    },
    fetchCardDetailsData: (state, action) => {},
    saveCreatedCardDetails: (state, action) => {
      const existingResults: any = state.cardDetails?.results ?? [];
      const incomingResults: any = action.payload?.results ?? [];
      const resultMap = new Map<any, any>();
      for (const card of existingResults) {
      resultMap.set(card.mid, card);
      }
      for (const card of incomingResults) {
      const existingCard = resultMap.get(card.mid);
      resultMap.set(card.mid, { ...existingCard, ...card });
      }
      state.cardDetails = {
        ...state.cardDetails,
        ...action.payload,
        results: Array.from(resultMap.values()),
        lastKey: action.payload.lastKey !== undefined ? action.payload.lastKey : state.cardDetails?.lastKey,
      };
    },
    savePhoneCountries: (state, action) => {
      state.phoneCountries = action.payload;
    },
    deleteCardData: (state, action) => {},
    bulkUploadCardsData: (state, action) => {},
    exportCardsData: (state, action) => {},
    fetchModifyCardDetails: (state, action) => {},
    sendTemplate: (state, action) => {},
    resetCardDetails: (state) => {
      state.cardDetails = null;
    },
    addReduceRistaCardBalance: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  createNewCardData,
  saveCardData,
  saveCreatedCardDetails,
  savePhoneCountries,
  fetchCardDetailsData,
  deleteCardData,
  bulkUploadCardsData,
  exportCardsData,
  fetchModifyCardDetails,
  sendTemplate,
  resetCardDetails,
  addReduceRistaCardBalance,
} = ristaCardSlice.actions;

export default ristaCardSlice.reducer;